
<template>
<CRow>
    <CCol col="12" sm="6" class="mx-auto">
        <CCard>
            <CCardBody>
                <Loading />
                <Message />

                <ValidationObserver class="col" tag="div" ref="form" v-slot="{ invalid, handleSubmit }">
                    <CForm method="post" @submit.prevent="handleSubmit(submit)">
                        <CRow>
                            <CCustomSearchableInput
                                v-if="selectableActiveStores"
                                col="12"
                                vid="active_store"
                                :name="$t('store.active')"
                                v-model="selectedActiveStore"
                                required
                                rules="required"
                                :items="selectableActiveStores"
                            />

                            <CCustomSearchableInput
                                v-if="selectableTerminatedStores"
                                col="12"
                                vid="terminated_store"
                                :name="$t('store.terminated')"
                                v-model="selectedTerminatedStore"
                                required
                                rules="required"
                                :items="selectableTerminatedStores"
                            />

                            <!-- <CCustomSelect
                                sm="12"
                                v-model="item.type"
                                :options="linkTypeOptionWithNull"
                                vid="type"
                                required
                                rules="required"
                                :name="$t('link.type')"
                            /> -->

                            <CCustomInput
                                sm="12"
                                vid="redirect_href"
                                :name="$t('link.redirect_href')"
                                rules="required"
                                required
                                ltr
                                v-model="item.redirect_href"
                            />
                        </CRow>

                        <CButton :disabled="invalid" type="submit"  color="primary" class="mt-3 px-4">{{ $t('submit') }}</CButton>
                    </CForm>
                </ValidationObserver>
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import { StoreStatus } from '@/constants'
import { mapActions, mapGetters } from 'vuex'
import { linkTypeOptionWithNull } from '@/common/data'

export default {
    name: 'ManageDisableLinks',

    data() {
        return {
            linkTypeOptionWithNull,
            selectedActiveStore: '',
            selectedTerminatedStore: '',
            item: {
                redirect_href: '',
                terminated_store: '',
                active_store: '',
                type: 0
            },
        }
    },

    computed: {
        ...mapGetters({
            stores: 'store/stores',
            selectableActiveStores: 'store/selectableActiveStores',
        }),
        // selectableActiveStores() {
        //     const stores = []
        //     Object.keys(this.stores).map(id => {
        //         if (this.stores[id].status === StoreStatus.ACTIVE) {
        //             stores.push({
        //                 value: id,
        //                 label: this.stores[id].name
        //             })
        //         }
        //     })

        //     return stores
        // },
        selectableTerminatedStores() {
            const stores = []
            Object.keys(this.stores).map(id => {
                if (this.stores[id].status === StoreStatus.TERMINATED) {
                    stores.push({
                        value: id,
                        label: this.stores[id].name
                    })
                }
            })

            return stores
        },
    },

    watch: {
        selectedActiveStore(val) {
            this.item.active_store = val.value || null
        },
        selectedTerminatedStore(val) {
            this.item.terminated_store = val.value || null
        }
    },

    methods: {
        ...mapActions({
            fetchStores: 'store/fetch',
            editDisableLinks: 'link/editDisableLinks',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            fetchLinks: 'link/fetch',
        }),
        submit() {
            this.setShowLoading()
            this.resetMsg()

            const item = {
                redirect_href: this.item.redirect_href,
                terminated_store: this.item.terminated_store,
                active_store: this.item.active_store,
                type: this.item.type,
            }

            this.editDisableLinks(item).then(() => {
                this.fetchLinks()
                this.$router.push({name: 'links'})
            }).catch(result => {
                if(result.data) {
                    this.$refs.form.setErrors(result.data)
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        }
    }
}
</script>